import { render, staticRenderFns } from "./CuentaPagos.vue?vue&type=template&id=072c6e90"
import script from "./CuentaPagos.vue?vue&type=script&lang=js"
export * from "./CuentaPagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports